// Module
var code = "<div> <table> <thead> <tr> <th>Source</th> <th>Table</th> <th class=\"withDarkBorder\">Column</th> <th>Target</th> <th>Table</th> <th>Column</th> <th>Message</th> </tr> </thead> <tbody></tbody> </table> </div> ";
// Exports
export default code;